export default __webpack_public_path__ + "static/media/warning_modavat_24_enabled.415d9654.svg";